import {Component, Input} from '@angular/core';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-date-display',
    templateUrl: './date-display.component.html',
    styleUrls: ['./date-display.component.css'],
    standalone: false
})
export class DateDisplayComponent {

  @Input()
  date: Date | undefined;

}
